// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as JsonCodec from "../../primitives/JsonCodec.res.js";
import * as TableView from "../../resources/tables/TableView.res.js";
import * as BarControl from "../../resources/layout-and-structure/BarControl.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as AsyncResult from "../../primitives/AsyncResult.res.js";
import * as QueryString from "../../primitives/QueryString.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as LegacyPagination from "../../resources/navigation/LegacyPagination.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

let make = React.memo(props => JsxRuntime.jsx(Box.make, {
  children: JsxRuntime.jsx(Button.make, {
    label: I18n.t("Reset"),
    variant: {
      NAME: "ghost",
      VAL: {}
    },
    size: "small",
    icon: "cross",
    onPress: props.onPress
  }),
  spaceLeft: "xsmall"
}));

let ResetFiltersButton = {
  make: make
};

function makeTotalPages(totalCount, nodesPerPage) {
  if (nodesPerPage <= 0 || totalCount <= 0) {
    return 1;
  } else if (Primitive_int.mod_(totalCount, nodesPerPage) === 0) {
    return Primitive_int.div(totalCount, nodesPerPage);
  } else {
    return Primitive_int.div(totalCount, nodesPerPage) + 1 | 0;
  }
}

function useQueryStringPersistReducer(codec, reducer, initialState) {
  let navigate = Navigation.useNavigate();
  let url = Navigation.useUrl();
  let initialState$1 = React.useMemo(() => {
    let urlState = JsonCodec.decodeWith(QueryString.parse(url.query), codec);
    let match = url.query;
    if (urlState.TAG === "Ok" && match !== "") {
      return urlState._0;
    } else {
      return initialState;
    }
  }, []);
  let match = React.useReducer(reducer, initialState$1);
  let state = match[0];
  React.useEffect(() => {
    let query = QueryString.stringify(JsonCodec.encodeWith(state, codec));
    let route = url.pathname + "?" + query;
    if (query !== url.query) {
      navigate({
        replace: true
      }, route);
    }
  }, [state]);
  return [
    state,
    match[1]
  ];
}

let edgesPerPage = 10;

function Make(funarg) {
  let makeQueryVariables = funarg.makeQueryVariables;
  let makeQueryVariablesFilterBy = funarg.makeQueryVariablesFilterBy;
  let cursorsFromQueryData = funarg.cursorsFromQueryData;
  let totalCountFromQueryData = funarg.totalCountFromQueryData;
  let rowsFromQueryDataAndState = funarg.rowsFromQueryDataAndState;
  let keyExtractor = funarg.keyExtractor;
  let useFiltersJsonCodec = funarg.useFiltersJsonCodec;
  let encoder = param => {
    let connectionArguments = param.connectionArguments;
    return [
      param.currentPage,
      param.previousPage,
      param.searchQuery,
      Primitive_option.some(param.filters),
      connectionArguments.first,
      connectionArguments.last,
      connectionArguments.after,
      connectionArguments.before
    ];
  };
  let value = (filtersCodec, initialFilters) => JsonCodec.object8(encoder, arg => ({
    TAG: "Ok",
    _0: {
      currentPage: Stdlib_Option.getOr(arg[0], 1),
      previousPage: Stdlib_Option.getOr(arg[1], -1),
      searchQuery: arg[2],
      filters: Stdlib_Option.getOr(arg[3], initialFilters),
      connectionArguments: {
        first: arg[4],
        last: arg[5],
        after: arg[6],
        before: arg[7]
      }
    }
  }), JsonCodec.optional(JsonCodec.field("page", JsonCodec.int)), JsonCodec.optional(JsonCodec.field("previousPage", JsonCodec.int)), JsonCodec.optional(JsonCodec.field("search", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("filters", filtersCodec)), JsonCodec.optional(JsonCodec.field("first", JsonCodec.int)), JsonCodec.optional(JsonCodec.field("last", JsonCodec.int)), JsonCodec.optional(JsonCodec.field("after", JsonCodec.string)), JsonCodec.optional(JsonCodec.field("before", JsonCodec.string)));
  let makeInitialState = filters => ({
    currentPage: 1,
    previousPage: -1,
    searchQuery: undefined,
    filters: filters,
    connectionArguments: {
      first: 10
    }
  });
  let makeConnectionArguments = (currentPage, previousPage, totalCount, cursors) => {
    if (currentPage === 1) {
      return {
        first: 10
      };
    }
    let startCursor = cursors[0];
    let exit = 0;
    if (startCursor !== undefined) {
      if (currentPage === (previousPage - 1 | 0)) {
        return {
          last: 10,
          before: startCursor
        };
      }
      exit = 2;
    } else {
      exit = 2;
    }
    if (exit === 2) {
      let endCursor = cursors[1];
      if (endCursor !== undefined && currentPage === (previousPage + 1 | 0)) {
        return {
          first: 10,
          after: endCursor
        };
      }
    }
    if (currentPage === makeTotalPages(totalCount, 10)) {
      return {
        last: 10
      };
    }
  };
  let use = initialState => {
    let reducer = (state, action) => {
      switch (action.TAG) {
        case "Navigated" :
          let nextPage = action.nextPage;
          let previousPage = state.currentPage;
          let maybeConnectionArguments = makeConnectionArguments(nextPage, previousPage, action.queryTotalCount, action.queryCursors);
          if (maybeConnectionArguments !== undefined) {
            return {
              currentPage: nextPage,
              previousPage: previousPage,
              searchQuery: state.searchQuery,
              filters: state.filters,
              connectionArguments: maybeConnectionArguments
            };
          } else {
            return state;
          }
        case "Searched" :
          let searchQuery = action._0;
          let tmp = searchQuery === "" ? undefined : searchQuery;
          return {
            currentPage: 1,
            previousPage: -1,
            searchQuery: tmp,
            filters: state.filters,
            connectionArguments: {
              first: 10
            }
          };
        case "FiltersUpdated" :
          return {
            currentPage: 1,
            previousPage: -1,
            searchQuery: state.searchQuery,
            filters: action._0(state.filters),
            connectionArguments: {
              first: 10
            }
          };
        case "Reset" :
          return action._0;
      }
    };
    let codec = value(useFiltersJsonCodec(), initialState().filters);
    return useQueryStringPersistReducer(codec, reducer, initialState());
  };
  let makeNextPage = (state, action, totalPages) => {
    let match = state.currentPage;
    if ((match === 0 || match === 1) && (totalPages === 0 || totalPages === 1)) {
      return;
    }
    switch (action) {
      case "First" :
        if (match >= 1) {
          return 1;
        } else {
          return;
        }
      case "Prev" :
        if (match > totalPages) {
          return totalPages;
        } else if (match > 1) {
          return match - 1 | 0;
        } else {
          return;
        }
      case "Next" :
        if (match > totalPages) {
          return totalPages;
        } else if (match >= 1 && match < totalPages) {
          return match + 1 | 0;
        } else {
          return;
        }
      case "Last" :
        if (match >= 1) {
          return totalPages;
        } else {
          return;
        }
    }
  };
  let Scaffold$Make = props => {
    let defaultQueryVariables = props.defaultQueryVariables;
    let __searchBar = props.searchBar;
    let __banner = props.banner;
    let __actions = props.actions;
    let __filters = props.filters;
    let dispatch = props.dispatch;
    let state = props.state;
    let subtitle = props.subtitle;
    let filters = __filters !== undefined ? __filters : null;
    let actions = __actions !== undefined ? __actions : null;
    let banner = __banner !== undefined ? __banner : null;
    let searchBar = __searchBar !== undefined ? __searchBar : null;
    let queryVariables = React.useMemo(() => {
      let filterBy = makeQueryVariablesFilterBy(state.filters);
      return makeQueryVariables(defaultQueryVariables, state.connectionArguments, state.searchQuery, Primitive_option.some(filterBy), undefined);
    }, [
      defaultQueryVariables,
      state
    ]);
    let asyncResult = AsyncResult.mapError(ApolloHelpers.queryResultToAsyncResult(funarg.useQuery(undefined, undefined, undefined, undefined, "CacheAndNetwork", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, queryVariables)), param => {});
    let onRequestPaginate = React.useCallback(action => {
      let queryData;
      if (typeof asyncResult !== "object") {
        return;
      }
      if (asyncResult.TAG === "Reloading") {
        let queryData$1 = asyncResult._0;
        if (queryData$1.TAG !== "Ok") {
          return;
        }
        queryData = queryData$1._0;
      } else {
        let queryData$2 = asyncResult._0;
        if (queryData$2.TAG !== "Ok") {
          return;
        }
        queryData = queryData$2._0;
      }
      let totalPages = makeTotalPages(totalCountFromQueryData(queryData), 10);
      let maybeNextPage = makeNextPage(state, action, totalPages);
      if (maybeNextPage === undefined) {
        return;
      }
      let queryTotalCount = totalCountFromQueryData(queryData);
      let queryCursors = cursorsFromQueryData(queryData);
      dispatch({
        TAG: "Navigated",
        nextPage: maybeNextPage,
        queryTotalCount: queryTotalCount,
        queryCursors: queryCursors
      });
    }, [
      state.currentPage,
      asyncResult
    ]);
    let pageVariation = subtitle !== undefined ? "standard" : "compact";
    let asyncTableRows = AsyncResult.mapOk(asyncResult, queryData => rowsFromQueryDataAndState(queryData, state));
    let columns = props.columns.map((column, index) => ({
      key: Stdlib_Option.getOr(column.name, "scaffold-key-" + index.toString()),
      name: Stdlib_Option.getOr(column.name, ""),
      layout: column.layout,
      render: row => column.render(row.data)
    }));
    let searchBar$1 = JsxRuntime.jsx(Box.make, {
      children: searchBar,
      spaceX: "large",
      spaceBottom: "xmedium"
    });
    let tmp;
    let exit = 0;
    let queryData;
    if (typeof asyncResult !== "object") {
      exit = 1;
    } else if (asyncResult.TAG === "Reloading") {
      let queryData$1 = asyncResult._0;
      if (queryData$1.TAG === "Ok") {
        queryData = queryData$1._0;
        exit = 2;
      } else {
        exit = 1;
      }
    } else {
      let queryData$2 = asyncResult._0;
      if (queryData$2.TAG === "Ok") {
        queryData = queryData$2._0;
        exit = 2;
      } else {
        exit = 1;
      }
    }
    switch (exit) {
      case 1 :
        tmp = JsxRuntime.jsx(LegacyPagination.make, {
          currentPage: 1,
          totalPages: 1,
          onRequestPaginate: onRequestPaginate
        });
        break;
      case 2 :
        tmp = JsxRuntime.jsx(LegacyPagination.make, {
          currentPage: state.currentPage,
          totalPages: makeTotalPages(totalCountFromQueryData(queryData), 10),
          onRequestPaginate: onRequestPaginate
        });
        break;
    }
    return JsxRuntime.jsxs(Page.make, {
      children: [
        JsxRuntime.jsx(BarControl.make, {
          filters: filters,
          actions: actions,
          banner: banner
        }),
        JsxRuntime.jsx(TableView.make, {
          data: asyncTableRows,
          columns: columns,
          keyExtractor: keyExtractor,
          hideReloadingPlaceholder: true,
          placeholderEmptyState: props.emptyState,
          searchBar: searchBar$1,
          onSearchQueryChange: searchQuery => dispatch({
            TAG: "Searched",
            _0: searchQuery
          })
        }),
        tmp
      ],
      variation: pageVariation,
      title: props.title,
      subtitle: subtitle,
      renderTitleEnd: props.renderTitleEnd
    });
  };
  let make = React.memo(Scaffold$Make, (oldProps, newProps) => {
    if (oldProps.title === newProps.title && oldProps.subtitle === newProps.subtitle && oldProps.state === newProps.state && oldProps.filters === newProps.filters && oldProps.actions === newProps.actions && oldProps.columns === newProps.columns && oldProps.banner === newProps.banner && oldProps.searchBar === newProps.searchBar && oldProps.emptyState === newProps.emptyState) {
      return oldProps.defaultQueryVariables === newProps.defaultQueryVariables;
    } else {
      return false;
    }
  });
  return {
    makeInitialState: makeInitialState,
    use: use,
    makeNextPage: makeNextPage,
    makeConnectionArguments: makeConnectionArguments,
    makeQueryVariables: makeQueryVariables,
    makeQueryVariablesFilterBy: makeQueryVariablesFilterBy,
    cursorsFromQueryData: cursorsFromQueryData,
    totalCountFromQueryData: totalCountFromQueryData,
    rowsFromQueryDataAndState: rowsFromQueryDataAndState,
    keyExtractor: keyExtractor,
    make: make
  };
}

export {
  ResetFiltersButton,
  makeTotalPages,
  edgesPerPage,
  useQueryStringPersistReducer,
  Make,
}
/* make Not a pure module */
